import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const accountId     = import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID;
const applicationId = import.meta.env.VITE_NEW_RELIC_APPLICATION_ID;
const licenseKey    = import.meta.env.VITE_NEW_RELIC_LICENSE_KEY;
const trustKey      = import.meta.env.VITE_NEW_RELIC_TRUST_KEY;

if (accountId && applicationId && licenseKey && trustKey) {
  new BrowserAgent({
    init: {
      ajax: { deny_list: ['bam.nr-data.net'] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      performance: { capture_detail: false, capture_marks: false, capture_measures: true },
      privacy: { cookies_enabled: true },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey,
      applicationID: applicationId,
      sa: 1,
    },
    loader_config: {
      accountID: accountId,
      agentID: applicationId,
      applicationID: applicationId,
      licenseKey,
      trustKey,
    },
  });
}
